import { $subscriber, SystemMessage } from "fire-wind-water";

const $message: any = new SystemMessage();

// 传递所有组件
$message["scms-template"] = (arg): void => {
  $subscriber.emit("scms-template", arg);
};

// 传递单个组件
$message["scms-component"] = (arg): void => {
  $subscriber.emit("scms-component", arg);
};

// 删除组件, 传组件id
$message["scms-component-delete"] = (arg): void => {
  $subscriber.emit("scms-component-delete", arg);
};

// 传递所有页面
$message["scms-page"] = (arg): void => {
  $subscriber.emit("scms-page", arg);
};
// 通知scms鼠标在那个组件上，参数格式
// {
//  top: 距离页面顶部的距离，left: 距离页面左边的距离， scrollTop: 页面上下滚动距离, isShow: 是否显示编辑组件， 1为显示，0为隐藏
//  }

export function $messageHover(data: {
  [label: string]: string | number;
}): void {
  $message.post({
    type: "stemplate-component-hover",
    data: data,
  });
}

// 通知scms模板是否加载完毕，1为加载完毕，可以接受message事件
export function $messageLoad(data: number): void {
  $message.post({
    type: "stemplate-loaded",
    data: data,
  });
}

// 通知scms当前模板有几个容器，为数据，第一个为主容器
export function $messageContainer(data): void {
  $subscriber.emit("stemplate-container", data);
  $message.post({
    type: "stemplate-container",
    data: data,
  });
}

export { $message };
